export default __webpack_public_path__ + "static/caseStudy3-uk-530bc52b9ff41169f1fa720b6e228c0d.webp";